import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { adminApi, setToken, formatApiErrorDetail } from "@/admin/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-white/25 py-4 text-lg text-[#F5F4EF] placeholder:text-[#F5F4EF]/40 focus:border-primary focus:outline-none transition-colors";

  return (
    <div data-testid="admin-login" className="min-h-screen bg-black text-[#F5F4EF] flex items-center justify-center px-6 grain relative">
      <div className="relative z-10 w-full max-w-md border border-white/15 p-10">
        <div className="flex items-center gap-3 mb-2">
          <span className="h-8 w-8 bg-primary flex items-center justify-center font-mono-accent text-sm text-white">R</span>
          <span className="font-display text-lg tracking-tight">RICH GLOBAL <span className="text-primary">RMC</span></span>
        </div>
        <div className="flex items-center gap-2 font-mono-accent text-xs uppercase tracking-[0.25em] text-signal-yellow mb-8">
          <Lock size={14} /> Admin Access
        </div>
        <h1 className="font-display text-4xl tracking-tighter mb-8">Sign in</h1>
        <form onSubmit={submit} className="space-y-8">
          <input data-testid="admin-email" className={inputCls} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password" className={inputCls} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 bg-primary text-white py-5 font-mono-accent text-xs uppercase tracking-[0.25em] hover:bg-signal-yellow hover:text-black transition-colors disabled:opacity-60"
          >
            {loading ? <><Loader2 size={18} className="animate-spin" /> Signing in…</> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
